import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '', fullScreen = false }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
    xlarge: 'w-16 h-16'
  };

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="text-center">
          <div className={`spinner ${sizeClasses.large} mx-auto mb-4`} />
          <p className="text-secondary-600 text-sm font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`spinner ${sizeClasses[size]}`} />
    </div>
  );
};

export default LoadingSpinner; 